import * as THREE from 'three'
import Model from './Model'
import Part from './Part'
import Section from './Section'

class Variant extends THREE.Group {
  uuid: string
  component: string
  part: Part
  model: Model
  sections: THREE.Group
  constructor({
    uuid,
    model,
    part,
    datatype,
    islands,
    structure,
  }: {
    uuid: string
    model: Model
    part: Part
    datatype: string
    islands: any
    structure: any
  }) {
    super()
    this.uuid = uuid
    this.component = 'variant'
    this.model = model
    this.part = part
    this.sections = new THREE.Group()

    if (datatype !== 'variant') {
      console.error(
        `There is an issues with the data provided` +
          `@model:${model.uuid}` +
          `@part:${uuid}`
      )
    }

    for (let sectionKey in structure) {
      const section_uuid = sectionKey
      const section_structure = structure[sectionKey]
      const parmObject = {
        uuid: section_uuid,
        model,
        part,
        variant: this,
        datatype: 'section',
        islands,
        structure: section_structure,
      }
      const section = new Section({ ...parmObject })
      this.sections.add(section)
    }
    this.add(this.sections)
  }
}

export default Variant
